const actionTypes = {
	SET_CHECKBOX_VALUE: 'SET_CHECKBOX_VALUE',
	SET_COLUMN_PREFERENCES: 'SET_COLUMN_PREFERENCES',
	SET_COLUMN_PREFERENCES_TABLE: 'SET_COLUMN_PREFERENCES_TABLE',
	SET_COLUMN_PREFERENCES_SUCCESS: 'SET_COLUMN_PREFERENCES_SUCCESS',
	SET_COLUMN_PREFERENCES_FAILURE: 'SET_COLUMN_PREFERENCES_FAILURE',
	GET_USER_PREFERENCES: 'GET_USER_PREFERENCES',
	GET_USER_PREFERENCES_SUCCESS: 'GET_USER_PREFERENCES_SUCCESS',
	GET_USER_PREFERENCES_FAILURE: 'GET_USER_PREFERENCES_FAILURE',
	GET_COLUMN_LIST: 'GET_COLUMN_LIST',
	GET_COLUMN_LIST_SUCCESS: 'GET_COLUMN_LIST_SUCCESS',
	GET_COLUMN_LIST_FAILURE: 'GET_COLUMN_LIST_FAILURE',
	SET_IS_DRAWER_OPEN: 'SET_IS_DRAWER_OPEN',
	SET_IS_METRICS_OPEN: 'SET_IS_METRICS_OPEN',

	GET_NET_SALES: 'GET_NET_SALES',
	GET_NET_SALES_SUCCESS: 'GET_NET_SALES_SUCCESS',
	GET_NET_SALES_FAILURE: 'GET_NET_SALES_FAILURE',

	GET_UNIT: 'GET_UNIT',
	GET_UNIT_SUCCESS: 'GET_UNIT_SUCCESS',
	GET_UNIT_FAILURE: 'GET_UNIT_FAILURE',

	GET_GMV: 'GET_GMV',
	GET_GMV_SUCCESS: 'GET_GMV_SUCCESS',
	GET_GMV_FAILURE: 'GET_GMV_FAILURE',

	GET_CHANNEL_BREAKDOWN_SALES: 'GET_CHANNEL_BREAKDOWN_SALES',
	GET_CHANNEL_BREAKDOWN_SALES_SUCCESS: 'GET_CHANNEL_BREAKDOWN_SALES_SUCCESS',
	GET_CHANNEL_BREAKDOWN_SALES_FAILURE: 'GET_CHANNEL_BREAKDOWN_SALES_FAILURE',
	GET_CHANNEL_BREAKDOWN_UNITS_SUCCESS: 'GET_CHANNEL_BREAKDOWN_UNITS_SUCCESS',
	GET_CHANNEL_BREAKDOWN_GMV_SUCCESS: 'GET_CHANNEL_BREAKDOWN_GMV_SUCCESS',

	SAVE_WEEK_FILTER: 'SAVE_WEEK_FILTER',

	SAVE_KPI_NAME: 'SAVE_KPI_NAME',

	SET_TAB_VALUE: 'SET_TAB_VALUE',

	SET_RCA_VALUE: 'SET_RCA_VALUE',

	UPDATE_SCREEN_WIDTH: 'UPDATE_SCREEN_WIDTH',

	SAVE_EVENT_TRACK_INFO: 'SAVE_EVENT_TRACK_INFO',

	GET_RULE_TYPE: 'GET_RULE_TYPE',
	GET_CREATE_RULE_DATA: 'GET_CREATE_RULE_DATA',
	GET_CREATE_RULE_SUCCESS: 'GET_CREATE_RULE_SUCCESS',
	GET_CREATE_RULE_FAILURE: 'GET_CREATE_RULE_FAILURE',

	DELETE_RULE: 'DELETE_RULE',
	DELETE_RULE_SUCCESS: 'DELETE_RULE_SUCCESS',
	DELETE_RULE_FAILURE: 'DELETE_RULE_FAILURE',

	REFRESH_WATCHLIST: 'REFRESH_WATCHLIST',

	GET_SEARCH_ITEM_RESULTS: 'GET_SEARCH_ITEM_RESULTS',
	GET_SEARCH_ITEM_RESULTS_SUCCESS: 'GET_SEARCH_ITEM_RESULTS_SUCCESS',
	GET_SEARCH_ITEM_RESULTS_FAILURE: 'GET_SEARCH_ITEM_RESULTS_FAILURE',
	UPDATE_SEARCH_ITEM_RESULTS: 'UPDATE_SEARCH_ITEM_RESULTS',
	UPDATE_SELECTED_ITEM: 'UPDATE_SELECTED_ITEM',
	UPDATE_SELECTED_ITEM_A: 'UPDATE_SELECTED_ITEM_A',
	UPDATE_SELECTED_ITEM_B: 'UPDATE_SELECTED_ITEM_B',
	UPDATE_ADD_ITEM_CHECKBOX: 'UPDATE_ADD_ITEM_CHECKBOX',
	UPDATE_ADD_PRODUCT_CHECKBOX: 'UPDATE_ADD_PRODUCT_CHECKBOX',

	GET_BULK_ITEM_SEARCH_RESULTS: 'GET_BULK_ITEM_SEARCH_RESULTS',
	GET_BULK_ITEM_SEARCH_RESULTS_SUCCESS: 'GET_BULK_ITEM_SEARCH_RESULTS_SUCCESS',
	GET_BULK_ITEM_SEARCH_RESULTS_FAILURE: 'GET_BULK_ITEM_SEARCH_RESULTS_FAILURE',
	UPDATE_BULK_ITEM_SEARCH_RESULTS: 'UPDATE_BULK_ITEM_SEARCH_RESULTS',

	POLL_START: 'POLL_START',
	GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
	GET_DATA_FAILURE: 'GET_DATA_FAILURE',

	PUT_NOTIFICATIONS_READ: 'MARK_NOTIFICATIONS_READ',
	PUT_NOTIFICATIONS_READ_SUCCESS: 'PUT_NOTIFICATIONS_READ_SUCCESS',
	PUT_NOTIFICATIONS_READ_FAILURE: 'MARK_NOTIFICATIONS_READ_FAILURE',

	GET_WATCH_LIST: 'GET_WATCH_LIST',
	GET_WATCH_LIST_SUCCESS: 'GET_WATCH_LIST_SUCCESS',
	GET_WATCH_LIST_FAILURE: 'GET_WATCH_LIST_FAILURE',

	GET_EDIT_RULE_DATA: 'GET_EDIT_RULE_DATA',

	SET_IS_CREATE_RULE_OPEN: 'SET_IS_CREATE_RULE_OPEN',
	SET_IS_CUSTOMIZE_COL_OPEN: 'SET_IS_CUSTOMIZE_COL_OPEN',
	SET_IS_WATCH_LIST_OPEN: 'SET_IS_WATCH_LIST_OPEN',
	SET_IS_NOTIFICATION_OPEN: 'SET_IS_NOTIFICATION_OPEN',
	UPDATE_LAST_CREATED_RULE: 'UPDATE_LAST_CREATED_RULE',

	GET_SUB_RULE_NOTIFICATION: 'GET_SUB_RULE_NOTIFICATION',
	GET_SUB_RULE_NOTIFICATION_SUCCESS: 'GET_SUB_RULE_NOTIFICATION_SUCCESS',
	GET_SUB_RULE_NOTIFICATION_FAILURE: 'GET_SUB_RULE_NOTIFICATION_FAILURE',

	GET_BUSINESS_HIERARCHY: 'GET_BUSINESS_HIERARCHY',
	GET_BUSINESS_HIERARCHY_SUCCESS: 'GET_BUSINESS_HIERARCHY_SUCCESS',
	GET_BUSINESS_HIERARCHY_FAILURE: 'GET_BUSINESS_HIERARCHY_FAILURE',
	SAVE_HIERARCHY_FILTER: 'SAVE_HIERARCHY_FILTER',

	GET_SAVED_HIERARCHY: 'GET_SAVED_HIERARCHY',
	GET_SAVED_HIERARCHY_SUCCESS: 'GET_SAVED_HIERARCHY_SUCCESS',
	GET_SAVED_HIERARCHY_FAILURE: 'GET_SAVED_HIERARCHY_FAILURE',

	SAVE_HIERARCHY: 'SAVE_HIERARCHY',
	SAVE_HIERARCHY_SUCCESS: 'SAVE_HIERARCHY_SUCCESS',
	SAVE_HIERARCHY_FAILURE: 'SAVE_HIERARCHY_FAILURE',

	SAVE_SEARCHED_HEIRARCHY: 'SAVE_SEARCHED_HEIRARCHY',
	CLEAR_SEARCHED_HEIRARCHY: 'CLEAR_SEARCHED_HEIRARCHY',

	OPEN_HIERARCHY_MODAL: 'OPEN_HIERARCHY_MODAL',

	CLICK_APPLY: 'CLICK_APPLY',

	DELETE_SAVED_HIERARCHY: 'DELETE_SAVED_HIERARCHY',
	DELETE_SAVED_HIERARCHY_SUCCESS: 'DELETE_SAVED_HIERARCHY_SUCCESS',
	DELETE_SAVED_HIERARCHY_FAILURE: 'DELETE_SAVED_HIERARCHY_FAILURE',

	EDIT_SAVED_HIERARCHY: 'EDIT_SAVED_HIERARCHY',
	EDIT_SAVED_HIERARCHY_SUCCESS: 'EDIT_SAVED_HIERARCHY_SUCCESS',
	EDIT_SAVED_HIERARCHY_FAILURE: 'EDIT_SAVED_HIERARCHY_FAILURE',

	EDIT_SAVED_HIERARCHY_DEFAULT_STATUS: 'EDIT_SAVED_HIERARCHY_DEFAULT_STATUS',

	EDIT_SELECTED_HIERARCHY: 'EDIT_SELECTED_HIERARCHY',

	GET_UPC_VALIDATION: 'GET_UPC_VALIDATION',
	GET_UPC_VALIDATION_SUCCESS: 'GET_UPC_VALIDATION_SUCCESS',
	GET_UPC_VALIDATION_FAILURE: 'GET_UPC_VALIDATION_FAILURE',

	SELECTED_UPCS: 'SELECTED_UPCS',

	SET_SELECTED_HIERARCHY: 'SET_SELECTED_HIERARCHY',

	SET_HIERRCHY_FILTER_RHID: 'SET_HIERRCHY_FILTER_RHID',

	SET_EDIT_FLOW: 'SET_EDIT_FLOW',
	SET_EDIT_HIERARCHY: 'SET_EDIT_HIERARCHY',

	VALIDATE_HIERARCHY: 'VALIDATE_HIERARCHY',
	VALIDATE_HIERARCHY_SUCCESS: 'VALIDATE_HIERARCHY_SUCCESS',
	VALIDATE_HIERARCHY_FAILURE: 'VALIDATE_HIERARCHY_FAILURE',

	RESET_VALIDATE_HIERARCHY: 'RESET_HIERARCHY',

	UPDATE_SAVED_HIERARCHY: 'UPDATE_SAVED_HIERARCHY',
	UPDATE_SAVED_HIERARCHY_SUCCESS: 'UPDATE_SAVED_HIERARCHY_SUCCESS',
	UPDATE_SAVED_HIERARCHY_FAILURE: 'UPDATE_SAVED_HIERARCHY_FAILURE',

	// TABLE FILTERS
	SET_VIEWBY_FILTER: 'SET_VIEWBY_FILTER',
	SET_BREAKDOWNBY_FILTER: 'SET_BREAKDOWNBY_FILTER',
	SET_TIME_PERIOD_FILTER: 'SET_TIME_PERIOD_FILTER',
	SET_NEW_TIME_PERIOD_FILTER: 'SET_NEW_TIME_PERIOD_FILTER',

	// DRILLDOWN ITEM
	GET_ITEM_UNIT_ON_HAND_INVENTORY: 'GET_ITEM_UNIT_ON_HAND_INVENTORY',
	GET_ITEM_UNIT_ON_HAND_INVENTORY_SUCCESS:
		'GET_ITEM_UNIT_ON_HAND_INVENTORY_SUCCESS',
	GET_ITEM_UNIT_ON_HAND_INVENTORY_FAILURE:
		'GET_ITEM_UNIT_ON_HAND_INVENTORY_FAILURE',
	GET_ITEM_RETAIL_ON_HAND_INVENTORY: 'GET_ITEM_RETAIL_ON_HAND_INVENTORY',
	GET_ITEM_RETAIL_ON_HAND_INVENTORY_SUCCESS:
		'GET_ITEM_RETAIL_ON_HAND_INVENTORY_SUCCESS',
	GET_ITEM_RETAIL_ON_HAND_INVENTORY_FAILURE:
		'GET_ITEM_RETAIL_ON_HAND_INVENTORY_FAILURE',
	GET_ITEM_BASIC_INFO: 'GET_ITEM_BASIC_INFO',
	GET_ITEM_BASIC_INFO_SUCCESS: 'GET_ITEM_BASIC_INFO_SUCCESS',
	GET_ITEM_BASIC_INFO_FAILURE: 'GET_ITEM_BASIC_INFO_FAILURE',
	GET_ITEM_NET_SALES_SUMMARY_CARD: 'GET_ITEM_NET_SALES_SUMMARY_CARD',
	GET_ITEM_NET_SALES_SUMMARY_CARD_SUCCESS:
		'GET_ITEM_NET_SALES_SUMMARY_CARD_SUCCESS',
	GET_ITEM_NET_SALES_SUMMARY_CARD_FAILURE:
		'GET_ITEM_NET_SALES_SUMMARY_CARD_FAILURE',
	GET_ITEM_IN_STOCK_SUMMARY_CARD: 'GET_ITEM_IN_STOCK_SUMMARY_CARD',
	GET_ITEM_IN_STOCK_SUMMARY_CARD_SUCCESS:
		'GET_ITEM_IN_STOCK_SUMMARY_CARD_SUCCESS',
	GET_ITEM_IN_STOCK_SUMMARY_CARD_FAILURE:
		'GET_ITEM_IN_STOCK_SUMMARY_CARD_FAILURE',
	GET_ITEM_STORE_COUNT_SUMMARY_CARD: 'GET_ITEM_STORE_COUNT_SUMMARY_CARD',
	GET_ITEM_STORE_COUNT_SUMMARY_CARD_SUCCESS:
		'GET_ITEM_STORE_COUNT_SUMMARY_CARD_SUCCESS',
	GET_ITEM_STORE_COUNT_SUMMARY_CARD_FAILURE:
		'GET_ITEM_STORE_COUNT_SUMMARY_CARD_FAILURE',
	GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD: 'GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD',
	GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_SUCCESS:
		'GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_SUCCESS',
	GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_FAILURE:
		'GET_ITEM_NIL_PICK_RATE_SUMMARY_CARD_FAILURE',
	GET_ITEM_CHANNEL_BREAKDOWN: 'GET_ITEM_CHANNEL_BREAKDOWN',
	GET_ITEM_CHANNEL_BREAKDOWN_SUCCESS: 'GET_ITEM_CHANNEL_BREAKDOWN_SUCCESS',
	GET_ITEM_CHANNEL_BREAKDOWN_FAILURE: 'GET_ITEM_CHANNEL_BREAKDOWN_FAILURE',
	GET_ITEM_NET_SALES: 'GET_ITEM_NET_SALES',
	GET_ITEM_NET_SALES_SUCCESS: 'GET_ITEM_NET_SALES_SUCCESS',
	GET_ITEM_NET_SALES_FAILURE: 'GET_ITEM_NET_SALES_FAILURE',
	GET_ITEM_UNITS: 'GET_ITEM_UNITS',
	GET_ITEM_UNITS_SUCCESS: 'GET_ITEM_UNITS_SUCCESS',
	GET_ITEM_UNITS_FAILURE: 'GET_ITEM_UNITS_FAILURE',
	GET_ITEM_RELATIVE_NET_SALES: 'GET_ITEM_RELATIVE_NET_SALES',
	GET_ITEM_RELATIVE_NET_SALES_SUCCESS: 'GET_ITEM_RELATIVE_NET_SALES_SUCCESS',
	GET_ITEM_RELATIVE_NET_SALES_FAILURE: 'GET_ITEM_RELATIVE_NET_SALES_FAILURE',
	GET_ITEM_RELATIVE_UNITS: 'GET_ITEM_RELATIVE_UNITS',
	GET_ITEM_RELATIVE_UNITS_SUCCESS: 'GET_ITEM_RELATIVE_UNITS_SUCCESS',
	GET_ITEM_RELATIVE_UNITS_FAILURE: 'GET_ITEM_RELATIVE_UNITS_FAILURE',
	GET_UNITS_CHANNEL_BREAKDOWN: 'GET_UNITS_CHANNEL_BREAKDOWN',
	GET_UNITS_CHANNEL_BREAKDOWN_SUCCESS: 'GET_UNITS_CHANNEL_BREAKDOWN_SUCCESS',
	GET_UNITS_CHANNEL_BREAKDOWN_FAILURE: 'GET_UNITS_CHANNEL_BREAKDOWN_FAILURE',
	GET_ITEM_ONHAND: 'GET_ITEM_ONHAND',
	GET_ITEM_ONHAND_SUCCESS: 'GET_ITEM_ONHAND_SUCCESS',
	GET_ITEM_ONHAND_FAILURE: 'GET_ITEM_ONHAND_FAILURE',
	GET_ITEM_ONHAND_UNITS: 'GET_ITEM_ONHAND_UNITS',
	GET_ITEM_ONHAND_UNITS_SUCCESS: 'GET_ITEM_ONHAND_UNITS_SUCCESS',
	GET_ITEM_ONHAND_UNITS_FAILURE: 'GET_ITEM_ONHAND_UNITS_FAILURE',
	GET_ITEM_ONORDER: 'GET_ITEM_ONORDER',
	GET_ITEM_ONORDER_SUCCESS: 'GET_ITEM_ONORDER_SUCCESS',
	GET_ITEM_ONORDER_FAILURE: 'GET_ITEM_ONORDER_FAILURE',
	GET_ITEM_ONORDER_UNITS: 'GET_ITEM_ONORDER_UNITS',
	GET_ITEM_ONORDER_UNITS_SUCCESS: 'GET_ITEM_ONORDER_UNITS_SUCCESS',
	GET_ITEM_ONORDER_UNITS_FAILURE: 'GET_ITEM_ONORDER_UNITS_FAILURE',
	GET_ITEM_DCTOSTORE: 'GET_ITEM_DCTOSTORE',
	GET_ITEM_DCTOSTORE_SUCCESS: 'GET_ITEM_DCTOSTORE_SUCCESS',
	GET_ITEM_DCTOSTORE_FAILURE: 'GET_ITEM_DCTOSTORE_FAILURE',
	GET_ITEM_DCTOSTORE_UNITS: 'GET_ITEM_DCTOSTORE_UNITS',
	GET_ITEM_DCTOSTORE_UNITS_SUCCESS: 'GET_ITEM_DCTOSTORE_UNITS_SUCCESS',
	GET_ITEM_DCTOSTORE_UNITS_FAILURE: 'GET_ITEM_DCTOSTORE_UNITS_FAILURE',
	GET_ITEM_INWHSE: 'GET_ITEM_INWHSE',
	GET_ITEM_INWHSE_SUCCESS: 'GET_ITEM_INWHSE_SUCCESS',
	GET_ITEM_INWHSE_FAILURE: 'GET_ITEM_INWHSE_FAILURE',
	GET_ITEM_INWHSE_UNITS: 'GET_ITEM_INWHSE_UNITS',
	GET_ITEM_INWHSE_UNITS_SUCCESS: 'GET_ITEM_INWHSE_UNITS_SUCCESS',
	GET_ITEM_INWHSE_UNITS_FAILURE: 'GET_ITEM_INWHSE_UNITS_FAILURE',
	GET_ITEM_INSTOCK: 'GET_ITEM_INSTOCK',
	GET_ITEM_INSTOCK_SUCCESS: 'GET_ITEM_INSTOCK_SUCCESS',
	GET_ITEM_INSTOCK_FAILURE: 'GET_ITEM_INSTOCK_FAILURE',
	GET_ITEM_INV_TREND: 'GET_ITEM_INV_TREND',
	GET_ITEM_INV_TREND_SUCCESS: 'GET_ITEM_INV_TREND_SUCCESS',
	GET_ITEM_INV_TREND_FAILURE: 'GET_ITEM_INV_TREND_FAILURE',
	GET_NIL_PICK_RATE: 'GET_NIL_PICK_RATE',
	GET_NIL_PICK_RATE_SUCCESS: 'GET_NIL_PICK_RATE_SUCCESS',
	GET_NIL_PICK_RATE_FAILURE: 'GET_NIL_PICK_RATE_FAILURE',
	GET_FIRTS_TIME_PICK_RATE: 'GET_FIRTS_TIME_PICK_RATE',
	GET_FIRTS_TIME_PICK_RATE_SUCCESS: 'GET_FIRTS_TIME_PICK_RATE_SUCCESS',
	GET_FIRTS_TIME_PICK_RATE_FAILURE: 'GET_FIRTS_TIME_PICK_RATE_FAILURE',
	GET_PRE_SUBSTITUTE_RATE: 'GET_PRE_SUBSTITUTE_RATE',
	GET_PRE_SUBSTITUTE_RATE_SUCCESS: 'GET_PRE_SUBSTITUTE_RATE_SUCCESS',
	GET_PRE_SUBSTITUTE_RATE_FAILURE: 'GET_PRE_SUBSTITUTE_RATE_FAILURE',
	GET_POST_SUBSTITUTE_RATE: 'GET_POST_SUBSTITUTE_RATE',
	GET_POST_SUBSTITUTE_RATE_SUCCESS: 'GET_POST_SUBSTITUTE_RATE_SUCCESS',
	GET_POST_SUBSTITUTE_RATE_FAILURE: 'GET_POST_SUBSTITUTE_RATE_FAILURE',
	GET_ITEM_NET_SALES_MAP_SUMMARY: 'GET_ITEM_NET_SALES_MAP_SUMMARY',
	GET_ITEM_NET_SALES_MAP_SUMMARY_SUCCESS:
		'GET_ITEM_NET_SALES_MAP_SUMMARY_SUCCESS',
	GET_ITEM_NET_SALES_MAP_SUMMARY_FAILURE:
		'GET_ITEM_NET_SALES_MAP_SUMMARY_FAILURE',
	GET_TOP_BOTTOM_ITEM_GRID: 'GET_TOP_BOTTOM_ITEM_GRID',
	GET_TOP_BOTTOM_SALES_ITEM_GRID: 'GET_TOP_BOTTOM_SALES_ITEM_GRID',
	GET_WEEK_OF_SUPPLY_STORE_DATA: 'GET_WEEK_OF_SUPPLY_STORE_DATA',
	GET_WEEK_OF_SUPPLY_STORE_SUCCESS: 'GET_WEEK_OF_SUPPLY_STORE_SUCCESS',
	GET_WEEK_OF_SUPPLY_STORE_FAILURE: 'GET_WEEK_OF_SUPPLY_STORE_FAILURE',
	GET_WEEK_OF_SUPPLY_DC_DATA: 'GET_WEEK_OF_SUPPLY_DC_DATA',
	GET_WEEK_OF_SUPPLY_DC_SUCCESS: 'GET_WEEK_OF_SUPPLY_DC_SUCCESS',
	GET_WEEK_OF_SUPPLY_DC_FAILURE: 'GET_WEEK_OF_SUPPLY_DC_FAILURE',
	GET_ITEM_LOCATION_GRID_STATE_DATA: 'GET_ITEM_LOCATION_GRID_STATE_DATA',
	GET_ITEM_LOCATION_GRID_STATE_SUCCESS: 'GET_ITEM_LOCATION_GRID_STATE_SUCCESS',
	GET_ITEM_LOCATION_GRID_STATE_FAILURE: 'GET_ITEM_LOCATION_GRID_STATE_FAILURE',
	GET_ITEM_LOCATION_GRID_STORE_DATA: 'GET_ITEM_LOCATION_GRID_STORE_DATA',
	GET_ITEM_LOCATION_GRID_STORE_SUCCESS: 'GET_ITEM_LOCATION_GRID_STORE_SUCCESS',
	GET_ITEM_LOCATION_GRID_STORE_FAILURE: 'GET_ITEM_LOCATION_GRID_STORE_FAILURE',
	GET_MAP_KEY: 'GET_MAP_KEY',
	GET_MAP_KEY_SUCCESS: 'GET_MAP_KEY_SUCCESS',
	GET_MAP_KEY_FAILURE: 'GET_MAP_KEY_FAILURE',

	SET_FIRST_TIME_USER: 'SET_FIRST_TIME_USER',
	SAVE_FIRST_TIME_USER_STATUS: 'SAVE_FIRST_TIME_USER_STATUS',
	SAVE_FIRST_TIME_USER_STATUS_SUCCESS: 'SAVE_FIRST_TIME_USER_STATUS_SUCCESS',
	SAVE_FIRST_TIME_USER_STATUS_FAILURE: 'SAVE_FIRST_TIME_USER_STATUS_FAILURE',

	RELOAD_SHOW_HIDE_COL: 'RELOAD_SHOW_HIDE_COL',

	GET_DATA_REFRESH_TIMESTAMPS: 'GET_DATA_REFRESH_TIMESTAMPS',
	GET_DATA_REFRESH_TIMESTAMPS_SUCCESS: 'GET_DATA_REFRESH_TIMESTAMPS_SUCCESS',
	GET_DATA_REFRESH_TIMESTAMPS_FAILURE: 'GET_DATA_REFRESH_TIMESTAMPS_FAILURE',

	SET_EXCEL_DOWNLOAD: 'SET_EXCEL_DOWNLOAD',
	SET_ENABLE_DOWNLOAD: 'SET_ENABLE_DOWNLOAD',

	SET_PERSONA: 'SET_PERSONA',

	CHANGE_PERSONA: 'CHANGE_PERSONA',
	GET_ERROR_DIALOG: 'GET_ERROR_DIALOG',

	RESET_FULL_COMPANY_VIEW_REDUCER: 'RESET_FULL_COMPANY_VIEW_REDUCER',

	/* Guided Insights - AD Page */

	GET_ANOMALY_DETECTION_DATA: 'GET_ANOMALY_DETECTION_DATA',
	GET_ANOMALY_DETECTION_DATA_SUCCESS: 'GET_ANOMALY_DETECTION_DATA_SUCCESS',
	GET_ANOMALY_DETECTION_DATA_FAILURE: 'GET_ANOMALY_DETECTION_DATA_FAILURE',

	GET_ANOMALIES_SALES_METRICS: 'GET_ANOMALIES_SALES_METRICS',
	GET_ANOMALIES_SALES_METRICS_SUCCESS: 'GET_ANOMALIES_SALES_METRICS_SUCCESS',
	GET_ANOMALIES_SALES_METRICS_FAILURE: 'GET_ANOMALIES_SALES_METRICS_FAILURE',

	UPDATE_TABLE_ROWS_AND_COLUMNS: 'UPDATE_TABLE_ROWS_AND_COLUMNS',
	RESET_AD_TABLE_ROWS: 'RESET_AD_TABLE_ROWS',

	SELECTED_UPC: 'SELECTED_UPC',

	GET_USER_AUTH: 'GET_USER_AUTH',
	GET_USER_AUTH_SUCCESS: 'GET_USER_AUTH_SUCCESS',
	GET_USER_AUTH_FAILURE: 'GET_USER_AUTH_FAILURE',
	DISABLE_DSADALERT: 'DISABLE_DSADALERT',
	DISABLE_DSADALERT_SUCCESS: 'DISABLE_DSADALERT_SUCCESS',
	DISABLE_DSADALERT_FAILURE: 'DISABLE_DSADALERT_FAILURE',

	GET_RCA_DATA: 'GET_RCA_DATA',
	GET_RCA_DATA_SUCCSS: 'GET_RCA_DATA_SUCCSS',
	GET_RCA_DATA_FAILURE: 'GET_RCA_DATA_FAILURE',

	SET_RCA_TABLE_COLUMNS: 'SET_RCA_TABLE_COLUMNS',
	SET_RCA_TABLE_ROWS: 'SET_RCA_TABLE_ROWS',

	UPDATE_RCA_TABLE_HEADERS_AND_ROWS: 'UPDATE_RCA_TABLE_HEADERS_AND_ROWS',
	UPDATE_INVENTORY_ROOTCAUSE: 'UPDATE_INVENTORY_ROOTCAUSE',

	UPDATE_INVENTORY_ROOTCAUSE_SUCCESS: 'UPDATE_INVENTORY_ROOTCAUSE_SUCCESS',
	UPDATE_INVENTORY_ROOTCAUSE_FAILURE: 'UPDATE_INVENTORY_ROOTCAUSE_FAILURE',

	SET_INVENTORY_REPL_THRESHOLD: 'SET_INVENTORY_REPL_THRESHOLD',

	// CHART COMPARISON
	SET_GRANULARITY: 'SET_GRANULARITY',
	SET_METRIC_A: 'SET_METRIC_A',
	SET_METRIC_B: 'SET_METRIC_B',
	SET_CHART_DATA_A: 'GET_CHART_DATA_A',
	SET_CHART_DATA_B: 'GET_CHART_DATA_B',
	CLEAR_METRIC_A: 'CLEAR_METRIC_A',
	CLEAR_METRIC_B: 'CLEAR_METRIC_B',
	FAILURE_A: 'FAILURE_A',
	FAILURE_B: 'FAILURE_B',
	SET_COMPARISON_CHART_TIME_PERIOD: 'SET_COMPARISON_CHART_TIME_PERIOD',

	SET_METRIC_A_ERROR_STATUS: 'SET_METRIC_A_ERROR_STATUS',
	SET_METRIC_B_ERROR_STATUS: 'SET_METRIC_B_ERROR_STATUS',
	SET_METRIC_A_LOADING_STATUS: 'SET_METRIC_A_LOADING_STATUS',
	SET_METRIC_B_LOADING_STATUS: 'SET_METRIC_B_LOADING_STATUS',

	SET_PRIMARY_OPTION_LIST: 'SET_PRIMARY_OPTION_LIST',
	SET_COMPARISON_OPTION_LIST: 'SET_COMPARISON_OPTION_LIST',

	SET_VIEW_BY_TYPE: 'SET_VIEW_BY_TYPE',
	SET_BREAK_DOWN_BY_TYPE: 'SET_BREAK_DOWN_BY_TYPE',

	SET_CUSTOM_ATTRIBUTE_NAMES: 'SET_CUSTOM_ATTRIBUTE_NAMES',

	RESET_FILTERS: 'RESET_FILTERS',

	GET_RCA_BDD_METRICS: 'GET_RCA_BDD_METRICS',
	GET_RCA_BDD_METRICS_SUCCESS: 'GET_RCA_BDD_METRICS_SUCCESS',
	GET_RCA_BDD_METRICS_FAILURE: 'GET_RCA_BDD_METRICS_FAILURE',
	UPDATE_INVENTORY_ROOTCAUSE_NO_DATA_SUCCESS:
		'UPDATE_INVENTORY_ROOTCAUSE_NO_DATA_SUCCESS',

	RESET_RCA_LOADING_STATE: 'RESET_RCA_LOADING_STATE',

	GET_STORE_DRILL_DOWN_DATA: 'GET_STORE_DRILL_DOWN_DATA',
	GET_STORE_DRILL_DOWN_DATA_SUCCESS: 'GET_STORE_DRILL_DOWN_DATA_SUCCESS',
	GET_STORE_DRILL_DOWN_DATA_FAILURE: 'GET_STORE_DRILL_DOWN_DATA_FAILURE',
};

export default actionTypes;
